import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormArray,
  AbstractControl,
  FormBuilder,
} from '@angular/forms';
import { TechnicalViewService } from 'src/app/_services/technical-view.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-update-job',
  templateUrl: './update-job.component.html',
  styleUrls: ['./update-job.component.scss'],
})
export class UpdateJobComponent implements OnInit {
  vehicle_id: any;
  chassis_no: any;
  data: any;
  loading = false;
  selectedHotkey: any;

  constructor(
    private technicalViewService: TechnicalViewService,
    private config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private fb: FormBuilder,
    private messageService: MessageService
  ) {}

  technicalForm = new FormGroup({
    vehicle_reference: new FormControl(''),
    vehicle_id: new FormControl(''),
    chassis_no: new FormControl(''),
    odometer: new FormControl(''),
    service_jobno: new FormControl(''),
    service_brakes: new FormControl(''),
    description_tag: new FormControl(''),
    remarks: new FormControl(''),
    record_type: new FormControl(''),
    date_completed: new FormControl(''),
    service_type: new FormControl(''),
    tyre_pos: new FormControl(''),
    tyre_size: new FormControl(''),
    tyre_type: new FormControl(''),
    technical_record_jobs: new FormArray([]),
  });

  ngOnInit(): void {
    this.data = this.config.data;
    // console.log('data', this.data);

    // Populate the FormArray
    this.data.technical_record_jobs.forEach((job: any) => {
      const technical_job = this.technicalViewService.getTechnicalJobForm();
      this.selectedHotkey = job.hotkey;

      // console.log('description_tag', job.job_description);

      // Set job data in the newly created FormGroup
      technical_job.patchValue({
        id: job.id,
        job_description: job.job_description,
        remarks: job.remarks,
      });

      // Push the FormGroup into the FormArray
      this.technicalJobArray.push(technical_job);
    });
  }

  get technicalJobArray() {
    return this.technicalForm.get('technical_record_jobs') as FormArray;
  }

  addOrder() {
    const technical_job = this.technicalViewService.getTechnicalJobForm();
    this.technicalJobArray.push(technical_job);
  }

  deleteOrder(index: number) {
    this.technicalJobArray.removeAt(index);
  }
}
